"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var Home = function Home(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#000' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size;
  var iconSize = size === 'original' ? 'width="23.98" height="20.51"' : 'width="100%"';
  var title = 'Home Icon';
  return "\n    <svg role=\"img\" aria-label=\"".concat(title, "\" xmlns=\"http://www.w3.org/2000/svg\" ").concat(iconSize, " viewBox=\"0 0 23.98 20.51\">\n      <title>").concat(title, "</title>\n      <path\n        d=\"M12,0,0,9.41H3.84v11.1h16.3V9.41H24Zm0,2.41,6.52,5.11h-13Zm-6.26,7H18.25v9.21H14.89V12.68H9.09v5.94H5.73ZM11,18.62h2V14.57H11Z\"\n        style=\"fill: ").concat(color, "; fill-rule: evenodd;\"\n      />\n    </svg>\n  ");
};

var _default = Home;
exports["default"] = _default;